export interface PhoneNumber {
  number: string;
  internationalCode?: string;
  countryCode?: string;
}
